import React, { useState } from "react";
import { Accordion } from "./Accordion";

function Faq() {
  const [activeAccordion, setActiveAccordion] = useState(0);

  const toggleAccordion = (index) => {
    setActiveAccordion((prev) => (prev === index ? null : index));
  };
  return (
    <section className="py-6 lg:py-12 relative faqGradientEffect max-w-[1280px] mx-auto flex flex-col items-centr justify-center">
      <div className="w-full flex justify-center  ">
        <h2 className="w-full max-w-[858px] text-center font-sans font-bold text-[clamp(1.75rem,5vw,2.5rem)] leading-none tracking-[-0.05em] uppercase gradient-text bg-left-bottom bg-textGd mb-5 overflow-hidden text-ellipsis text-black">
          Frequently asked questions
        </h2>
      </div>
      <div className="space-y-[15px] *:w-full flex flex-col ">
        <Accordion
          className=""
          show
          index={0}
          isActive={activeAccordion === 0}
          toggleAccordion={toggleAccordion}
          count="1 ."
          question="What is Router Nitro Bridge, and how does it work?"
          answer="The Router Nitro Bridge is a secure, decentralized platform that enables seamless token swaps across different blockchains. For example, you can use the bridge to exchange ETH or other supported tokens for $VANRY on the Vanar blockchain. The process is real-time, ensuring quick and efficient transfers between chains."
        />
        <Accordion
          index={1}
          isActive={activeAccordion === 1}
          toggleAccordion={toggleAccordion}
          count="2 ."
          question="What cryptocurrencies can I use to buy $VANRY?"
          answer={`
                        <p className="mb-2">You can buy $VANRY using a wide range of cryptocurrencies, including:</p>
                        <ul className="space-y-2 mb-2">
                        <li>1. ETH (Ethereum)</li>
                        <li>2. BTC (Bitcoin)</li>
                        <li>3. USDT (Tether)</li>
                        <li>4. USDC (USD Coin)</li>
                        <li>5. DAI (MakerDAO Stablecoin)</li>
                        <li>6. BNB (Binance Coin)</li>
                        <li>7. XRP (Ripple)</li>
                        <li>8. MATIC (Polygon)</li>
                        <li>9. TRX (Tron)</li>
                        <li>10. ADA (Cardano)</li>
                        </ul>
                    <p>More tokens will be supported over time to expand compatibility.</p>
                    `}
        ></Accordion>
        <Accordion
          index={2}
          isActive={activeAccordion === 2}
          toggleAccordion={toggleAccordion}
          count="3 ."
          question="What fees are associated with bridging?"
          answer={`
                        <p className="mb-2">The Router Nitro Bridge charges a minimal transaction fee to facilitate cross-chain swaps. These fees cover:</p>
                        <ul className="space-y-2 mb-2">
                        <li><strong>Gas fees :</strong> Associated with the blockchain you are transferring from and to.</li>
                        <li><strong>Service fee :</strong> A small percentage for maintaining the bridge's secure operations.</li>
                        <li>Competitive rates ensure you get the best value for your transaction, and fees are displayed transparently before you confirm the swap.</li>
                        </ul>
                    `}
        ></Accordion>
        <Accordion
          index={3}
          isActive={activeAccordion === 3}
          toggleAccordion={toggleAccordion}
          count="4 ."
          question="How long does it take to complete a bridge transaction?"
          answer={`
                        <p className="mb-2">Bridge transactions are typically completed in <strong>real time</strong>, depending on the blockchain's network congestion.</p>
                        <ul className="space-y-2 mb-2">
                        <li>1. For most tokens, the process takes <strong>a few minutes.</strong></li>
                        <li>2. In rare cases of network delays, the transaction may take up to <strong>15 minutes.</strong></li>
                        <li>If your transaction takes longer, you can track its status using the provided transaction hash.</li>
                        </ul>
                    `}
        ></Accordion>
      </div>
    </section>
  );
}

export default Faq;
